import type {
    Category,
    TransformedSubItemForMatrices,
} from '@routes/sidebar/admin-center/tenant-client/___pages___/matrices/ui/___shared___/components/custom-category-selector/types.ts';

export const getNormalizedSubItems = (
    subItems: TransformedSubItemForMatrices[],
    levelOneItems: Category[],
    levelTwoItems: Category[],
): TransformedSubItemForMatrices[] => {
    const levelOneOrder = new Map(levelOneItems.map((it, idx) => [it.value, idx]));
    const levelTwoOrder = new Map(levelTwoItems.map((it, idx) => [it.value, idx]));

    return subItems
        .filter((si) => levelOneOrder.has(si.category) && levelTwoOrder.has(si.type))
        .sort((a, b) => {
            const levelTwoOrderDiff = (levelTwoOrder.get(a.type) ?? 0) - (levelTwoOrder.get(b.type) ?? 0);
            if (levelTwoOrderDiff !== 0) return levelTwoOrderDiff;

            const labelCompare = a.label.localeCompare(b.label);
            if (labelCompare !== 0) return labelCompare;

            return (levelOneOrder.get(a.category) ?? 0) - (levelOneOrder.get(b.category) ?? 0);
        });
};

export const getNextSelectedGroupsAndTypes = (
    selectedGroupValues: string[],
    selectedTypeValues: string[],
    isLevelOneLabel: boolean,
    labelValue: string,
) => {
    const nextSelectedGroups = new Set(selectedGroupValues);
    const nextSelectedTypes = new Set(selectedTypeValues);

    if (isLevelOneLabel) {
        if (nextSelectedGroups.has(labelValue)) {
            nextSelectedGroups.delete(labelValue);
        } else {
            nextSelectedGroups.add(labelValue);
        }
    } else {
        if (nextSelectedTypes.has(labelValue)) {
            nextSelectedTypes.delete(labelValue);
        } else {
            nextSelectedTypes.add(labelValue);
        }
    }

    return {
        groups: [...nextSelectedGroups],
        types: [...nextSelectedTypes],
    };
};

export const getNextCheckedSubItems = (
    selectedGroupValues: string[],
    selectedTypeValues: string[],
    levelOneItems: Category[],
    levelTwoItems: Category[],
    allSubItems: TransformedSubItemForMatrices[],
) => {
    const activeGroups =
        selectedGroupValues.length > 0 ? new Set(selectedGroupValues) : new Set(levelOneItems.map((g) => g.value));
    const activeTypes =
        selectedTypeValues.length > 0 ? new Set(selectedTypeValues) : new Set(levelTwoItems.map((t) => t.value));

    return new Set(
        allSubItems
            .filter(({ category, type }) => activeGroups.has(category) && activeTypes.has(type))
            .map(({ value }) => value),
    );
};
